/*
 * File: SalesOrderPayloadModel.ts
 * Project: papa-bear
 * -----
 * Last Modified: 08 Dec 2021 5:50:14 pm
 * -----
 * Copyright (c) 2021 Elegant Software Solutions All rights reserved.
 */
import { RcFile } from 'antd/lib/upload';
import * as yup from 'yup';
import { ProductSubType } from './ProductSubType';

// export interface SalesOrderLinesPayloadModel {
//   category?: string | null;
//   conditionId: string;
//   customerLineNumber?: string | null;
//   deliveryType: string;
//   description?: string;
//   dispositionId: string;
//   extendedPrice?: number;
//   id: string;
//   isCategoryValidated: boolean;
//   isConditionValidated: boolean;
//   isDeliveryTypeValidated: boolean;
//   isDispositionValidated: boolean;
//   isManufacturerValidated: boolean;
//   isOwnerValidated: boolean;
//   isPosted?: boolean | null;
//   isProductNumberValidated: boolean;
//   isSiteValidated: boolean;
//   isVendorValidated: boolean;
//   isWarehouseValidated: boolean;
//   lineNumber: number;
//   manufacturer?: string | null;
//   ownerId: string;
//   productNumber: string;
//   quantity?: number;
//   siteId: string;
//   totalCost?: number;
//   unitCost?: number;
//   unitPrice?: number;
//   vendorId?: string;
//   warehouseId: string;
//   sublines: {
//     lineNumber: number;
//     productDescription: string;
//     quantity: number;
//   }[];
// }
export interface SalesOrderLinesPayloadModel {
  alternateItemId?: string | null;
  category?: string | null;
  conditionId: string | null;
  customerLineNumber?: string | null;
  deliveryType: string;
  description?: string | null;
  dispositionId: string | null;
  extendedPrice: number;
  id: string;
  isCategoryValidated?: boolean;
  isConditionValidated?: boolean;
  isDeliveryTypeValidated?: boolean;
  isDispositionValidated?: boolean;
  isManufacturerValidated?: boolean;
  isOwnerValidated?: boolean;
  isPosted?: boolean;
  isProductNumberValidated?: boolean;
  isSiteValidated?: boolean;
  isVendorValidated?: boolean;
  isWarehouseValidated?: boolean;
  lineNumber: number;
  manufacturer?: string | null;
  ownerId: string | null;
  productNumber: string;
  quantity: number;
  siteId: string | null;
  subLines?: ProductSubType[];
  totalCost: number;
  unitCost: number;
  unitPrice: number;
  vendorId?: string | null;
  warehouseId: string | null;
}

export interface SalesOrderPayloadModel {
  attachments?: RcFile[];
  id?: string;
  attention?: string | null;
  buyerId: string;
  buyerName: string;
  convertedFromQuote: boolean;
  currencyCode: string;
  customerId: string;
  customerName: string;
  customerPo: string;
  dataAreaId: string;
  deliveryAddressCity: string;
  deliveryAddressName?: string | null;
  deliveryAddressCountry?: string;
  deliveryAddressCounty?: string | null;
  inventoryReservationMethod: string;
  deliveryAddressDescription?: string;
  deliveryAddressFormatted?: string;
  deliveryAddressLocationId: string;
  deliveryAddressState: string;
  deliveryAddressStreet: string;
  deliveryAddressZipCode: string;
  deliveryContactName: string;
  deliveryContactPhone: string;
  deliveryDate: string;
  freightTerms: string;
  isActive: boolean;
  labConfiguration: boolean;
  languageId: string;
  lines: SalesOrderLinesPayloadModel[];
  modeOfDelivery: string;
  paymentTerms?: string | null;
  quoteId?: string | null;
  requestedShipDate: string;
  salesOrderType: string;
  salesPersonFullName: string;
  salesPersonPersonnelNumber: string;
  salesSupportFullName: string;
  salesSupportPersonnelNumber: string;
  salesTaxGroupCode: string;
  shipComplete: boolean;
  siteId: string;
  status?: string | null;
  warehouseId: string;
}

// export const salesOrderLinePayloadSchema: yup.SchemaOf<SalesOrderLinesPayloadModel> = yup.object({
//   id: yup.string().required(),
//   category: yup.string().nullable(),
//   conditionId: yup.string().required(),
//   customerLineNumber: yup.string().nullable(),
//   deliveryType: yup.string().required(),
//   description: yup.string(),
//   isPosted: yup.boolean().nullable(),
//   dispositionId: yup.string().required(),
//   extendedPrice: yup.number(),
//   manufacturer: yup.string().nullable(),
//   ownerId: yup.string().required(),
//   productNumber: yup.string().required(),
//   quantity: yup.number(),
//   siteId: yup.string().required(),
//   totalCost: yup.number(),
//   unitCost: yup.number(),
//   unitPrice: yup.number(),
//   vendorId: yup.string(),
//   warehouseId: yup.string().required(),
//   isCategoryValidated: yup.boolean().required(),
//   isConditionValidated: yup.boolean().required(),
//   isDeliveryTypeValidated: yup.boolean().required(),
//   isDispositionValidated: yup.boolean().required(),
//   isManufacturerValidated: yup.boolean().required(),
//   isOwnerValidated: yup.boolean().required(),
//   isProductNumberValidated: yup.boolean().required(),
//   isSiteValidated: yup.boolean().required(),
//   isVendorValidated: yup.boolean().required(),
//   isWarehouseValidated: yup.boolean().required(),
//   sublines: yup.array(),
//   lineNumber: yup.number().required()
// });
export const salesOrderLinePayloadSchema: yup.SchemaOf<SalesOrderLinesPayloadModel> = yup.object({
  alternateItemId: yup.string().nullable(),
  category: yup.string().nullable(),
  conditionId: yup.string().nullable().required(),
  customerLineNumber: yup.string().nullable(),
  deliveryType: yup.string().required(),
  description: yup.string().nullable(),
  dispositionId: yup.string().nullable().required(),
  extendedPrice: yup.number().required(),
  id: yup.string().required(),
  isCategoryValidated: yup.boolean().required(),
  isConditionValidated: yup.boolean().required(),
  isDeliveryTypeValidated: yup.boolean().required(),
  isDispositionValidated: yup.boolean().required(),
  isManufacturerValidated: yup.boolean().required(),
  isOwnerValidated: yup.boolean().required(),
  isPosted: yup.boolean().required(),
  isProductNumberValidated: yup.boolean().required(),
  isSiteValidated: yup.boolean().required(),
  isVendorValidated: yup.boolean().required(),
  isWarehouseValidated: yup.boolean().required(),
  lineNumber: yup.number().required(),
  manufacturer: yup.string().nullable(),
  ownerId: yup.string().nullable().required(),
  productNumber: yup.string().nullable().required(),
  quantity: yup.number().required(),
  siteId: yup.string().nullable().required(),
  subLines: yup.array(),
  totalCost: yup.number().required(),
  unitCost: yup.number().required(),
  unitPrice: yup.number().required(),
  vendorId: yup.string().nullable(),
  warehouseId: yup.string().nullable().required()
});

export const salesOrderPayloadSchema: yup.SchemaOf<SalesOrderPayloadModel> = yup.object({
  id: yup.string(),
  attention: yup.string().nullable(),
  attachments: yup.array(),
  buyerId: yup.string().required(),
  buyerName: yup.string().required(),
  convertedFromQuote: yup.boolean().required(),
  deliveryAddressName: yup.string().nullable(),
  inventoryReservationMethod: yup.string().required(),
  currencyCode: yup.string().required(),
  customerId: yup.string().required(),
  customerName: yup.string().required(),
  customerPo: yup.string().required(),
  dataAreaId: yup.string().required(),
  deliveryAddressCity: yup.string().required(),
  deliveryAddressCountry: yup.string(),
  deliveryAddressCounty: yup.string(),
  deliveryAddressDescription: yup.string().required(),
  deliveryAddressFormatted: yup.string(),
  deliveryAddressLocationId: yup.string().required(),
  deliveryAddressState: yup.string().required(),
  deliveryAddressStreet: yup.string().required(),
  deliveryAddressZipCode: yup.string().required(),
  deliveryContactName: yup.string().required(),
  deliveryContactPhone: yup.string().required(),
  deliveryDate: yup.string().required(),
  freightTerms: yup.string().required(),
  isActive: yup.boolean().required(),
  labConfiguration: yup.boolean().required(),
  languageId: yup.string().required(),
  lines: yup.array(salesOrderLinePayloadSchema),
  modeOfDelivery: yup.string().required(),
  paymentTerms: yup.string().nullable(),
  quoteId: yup.string().nullable(),
  requestedShipDate: yup.string().required(),
  salesOrderType: yup.string().required(),
  salesPersonFullName: yup.string().required(),
  salesPersonPersonnelNumber: yup.string().required(),
  salesSupportFullName: yup.string().required(),
  salesSupportPersonnelNumber: yup.string().required(),
  salesTaxGroupCode: yup.string().required(),
  shipComplete: yup.boolean().required(),
  siteId: yup.string().required(),
  status: yup.string().nullable(),
  warehouseId: yup.string().required()
});
